import React, { Component } from 'react'
import { Link, Route } from 'react-router-dom'
import { Checkbox, Input, Select, Cascader, AutoComplete, Button, Upload, Modal, Icon, Menu, Dropdown, Table, Col, Row, Pagination, Popover, Popconfirm, Spin } from 'antd';
// import { PlusOutlined } from '@ant-design/icons';
import { app, api, config } from '../app'

import '../css/Inspection.css'
// import addressOptions from '../util/cascader-address-options'



const { TextArea } = Input;
const { Option } = Select;
const { Search } = Input;


function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

function beforeUpload(file) {
    let format = ['image/jpeg', 'image/jpg', 'image/png'];
    const is = format.indexOf(file.type) > -1;
    if (!is) {
        app.alert('仅可上传文件类型为: ' + format.join("、"), 'warn');
        return Promise.reject();
    }
    return Promise.resolve();
}

export default class Inspection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading:true,
            indexInfo: [],   //首页内容(公告，督查回声等)
            provinceList: [],   //省级列表
            cicyList: [],   //城市列表
            cicyProperList: [],   //城区列表
            cascaderInfo: [],   //选择的城市
            teamList: [],   //队伍列表
            searchTeamnoValue: '',  //搜索框内容
            previewVisible: false,
            previewImage: '',
            previewTitle: '',
            fileList: [],
            loginFlag: false,
            loginVisible: false,
            login_title: [
                {
                    title: '系统身份登录',
                    id: 1,
                    active: true
                },
                {
                    title: '非存心内部人员登录',
                    id: 2,
                    active: false
                }
            ],
            applicationFlag: false,
            application: [
                {
                    title: '个人注册',
                    id: 1,
                    active: true
                }
            ],
            forgetMessageFlag: false,
            forgetMessage: [
                {
                    title: '忘记密码',
                    id: 1,
                    active: true
                }
            ],
            account: '',    //登录帐号=》登录电话号码
            password: '',   //登录密码
            loginInfo: [],  //登录信息
            application_mobile: '',
            application_sms: '',
            application_name: '',
            application_idno: '',
            application_password: '',
            application_confirm_password: '',

            forgetMessage_mobile: '',
            forgetMessage_sms: '',
            forgetMessage_password: '',
            forgetMessage_confirm_password: '',

            check_my_leavingMessage: false,     //是否查看我的留言
            my_leavingMessage: [],     //我的留言数据列表
            total: 0,    //我的留言列表总数量
            page: 1,     //我的留言列表页数
            message_detail: false,   //我的留言详情弹窗
            message_detail_info: [],     //我的留言详情数据
            message_detail_imgFlag: false,   //我的留言图片预览弹窗
            message_detail_img: '',  //我的留言图片预览图片地址

            mitMessage_secret: 1,    //留言保密状态（1默认公开 2保密）
            mitMessage_title: '',    //标题
            mitMessage_content: '',  //内容
            mitMessage_url: [],      //图片（;;;隔开最多5张）
            mitMessage_province: '', //省
            mitMessage_city: '', //市
            mitMessage_region: '',   //区
            mitMessage_address: '',  //详细地址
            mitMessage_teamno: '',   //搜索选择的队伍编号
            mitMessage_nickname: '', //昵称
            mitMessage_email: '',    //邮箱
            mitMessage_professional: '', //职业
            mitMessage_user_info_secret: 1,  //用户信息状态（1默认公开 2保密）


            message_tips_modal: false,   //留言提示

        };
    }


    componentDidMount() {
        app.post(api.InspectionHomeData, {}).then(res => {
            let { flag, data, msg } = res;
            if (flag == 1) {
                this.setState({
                    indexInfo: data,
                    loading:false
                }, () => { app.alert(msg, 'success', '45%'); })

            } else {
                app.alert(msg, 'error', '45%')
            }

        })

    }

    check = (e) => {
        
        if (this.state[e.target.name] == 2) {
            this.setState({
                [e.target.name]: 1   //公开
            },()=>console.log(this.state[e.target.name]))
        } else {
            this.setState({
                [e.target.name]: 2   //保密
            },()=>console.log(this.state[e.target.name]))
        }
        
    }

    //  请求城市信息
    getCityInfo = async (parent_id = 0) => {
        // 发送请求获取城市
        let { data, msg, flag } = await app.post(api.InspectionAreaList, { uid: this.state.loginInfo.uid, utoken: this.state.loginInfo.utoken, parent_id });
        if (flag == 1) {
            this.setState({
                provinceList: data,
                cicyList: [],
                cicyProperList: []
            })
        } else {
            app.alert(msg, "error", '45%')
        }


    }

    //  获取选择的城市
    getCity = async (e) => {
        console.log(e)
        this.setState({ mitMessage_province: e })
        let { data, msg, flag } = await app.post(api.InspectionAreaList, { uid: this.state.loginInfo.uid, utoken: this.state.loginInfo.utoken, parent_id: e });

        if (flag == 1) {
            this.setState({
                cicyList: data,
                cicyProperList: []
            })
        } else {
            app.alert(msg, "error")
        }
    }

    //  获取请求的市区
    get_cicyProperList = async (e) => {
        this.setState({ mitMessage_city: e })
        let { data, msg, flag } = await app.post(api.InspectionAreaList, { uid: this.state.loginInfo.uid, utoken: this.state.loginInfo.utoken, parent_id: e });

        if (flag == 1) {
            this.setState({
                cicyProperList: data
            })
        } else {
            app.alert(msg, "error")
        }
    }
    //  获取请求的市区id但不进行请求
    get_cicyProper = async (e) => this.setState({ mitMessage_region: e })
    // this.setState({mitMessage_province:e[0],mitMessage_city:e[1],mitMessage_region:e[2]})


    onChangeTeamName = async (value) => {
        this.setState({
            searchTeamnoValue: value
        })
        if (value.trim() == '') {
            return
        }
        let { data, flag, msg } = await app.post(api.InspectionAreaTeam, { uid: this.state.loginInfo.uid, utoken: this.state.loginInfo.utoken, teanmane: value.trim() })
        if (flag == 1 && msg != "未搜到相关内容") {
            let teamList = []
            let mitMessage_teamno = ''
            data.forEach(i => {
                if (i.teamname.indexOf("（已下架）") == -1) {
                    teamList.push(i.teamname)
                    mitMessage_teamno = i.teamno
                }

            })

            this.setState({
                teamList,
                mitMessage_teamno
            })
        } else {
            // 如果没有发现有相关内容，那么清除缓存内容
            this.setState({
                teamList: [],
                mitMessage_teamno: '',
            })
        }

    }

    /* 
    *   关闭图片预览弹窗
    *
    * 
     */
    handleCancel = () => this.setState({ previewVisible: false, account: '', password: '' });
    /* 
    *   图片处理
    *
    * 
     */
    handlePreview = async file => {
        console.log(1)
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }

        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
            previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
        });
    };
    /* 
    *   图片上传
    *
    * 
     */
    handleChange = ({ fileList }) => this.setState({ fileList })


    /*
    *  判断是否已登录
    *
    */
    ifLogin = () => {
        let { loginFlag } = this.state
        if (loginFlag) {
            //当前已登录
            return
        }
        //未登录,打开登录注册弹窗
        this.openLogin()

    }

    /* 
    *   打开登录弹窗
    */
    openLogin = () => this.setState({ loginVisible: true })

    /* 
    *   关闭登录弹窗
    */
    handleCancelLogin = () => {
        this.setState({
            loginVisible: false
        }, () => {
            this.setTopNav(0)
            this.setState({

                applicationFlag: false,
                forgetMessageFlag: false,

                application_mobile: '',
                application_sms: '',
                application_name: '',
                application_idno: '',
                application_password: '',
                application_confirm_password: '',

                forgetMessage_mobile: '',
                forgetMessage_sms: '',
                forgetMessage_password: '',
                forgetMessage_confirm_password: '',
            })
        })
    }


    /* 
    *   修改导航栏
    *   @index  登录弹窗中所点击的导航栏数据的index
     */
    setTopNav = (index) => {
        let login_title = this.state.login_title
        login_title.forEach(i => i.active = false)
        login_title[index].active = true
        this.setState({
            login_title: login_title,
            account: '',
            password: ''
        })
    }
    /*
    *  注册获取手机验证码
    *
    */
    getSms = async () => {
        let { application_mobile: mobile } = this.state
        if (mobile.trim() == '') {
            app.alert('手机号码未填写', 'error', '45%');
            return
        } else {
            let { flag, msg } = await app.post(api.ApplyUserSendSMS, { mobile })
            if (flag == 1) { app.alert(msg, 'success', '45%'); return }
            app.alert(msg, 'error', '45%')
        }
    }

    /*
    *  动态修改value
    *
    */
    _changeValue = (e) => this.setState({ [e.target.name]: e.target.value })

    /*
    *  登录
    *  @type 登录方式（1系统人员 2游客） 
    */
    login = async (type) => {
        let { account, password } = this.state
        if (account.trim() == '') {
            app.alert('登录手机号码未填写', 'error', '45%')
            return
        }
        if (password.trim() == '') {
            app.alert('登录密码未填写', 'error', '45%')
            return
        }
        this.setState({
            loading:true
        })
        let { data, flag, msg } = await app.post(api.ApplyUserLogin, { mobile: account, password, type })
        if (flag == 1) {

            this.setState({ loginInfo: data, loginFlag: true }, () => { app.alert(msg, 'success', '45%'); this.handleCancelLogin(); this.getCityInfo(), this.dataSource() })
        } else {
            
            app.alert(msg, 'error', '45%')
        }
        this.setState({loading:false})
    }
    /*
    *  退出登录
    *  
    */
    logout = async () => {
        this.setState({
            loading:true
        })
        let { flag, msg } = await app.post(api.ApplyUserLogout, { uid: this.state.loginInfo.uid, utoken: this.state.loginInfo.utoken })
        if (flag == 1) {
            this.setState({ loginInfo: [], loginFlag: false }, () => { app.alert(msg, 'success', '45%'); })
        } else {
            app.alert(msg, 'error', '45%')
        }
        this.setState({loading:false})

    }


    /* 
    *   注册
    *
    * 
     */
    application = async () => {
        let { application_mobile: mobile, application_sms: sms, application_name: name, application_idno: idno, application_password: password, application_confirm_password: password_confirm } = this.state
        if (mobile.trim() == '') {
            app.alert('手机号码未填写', 'error', '45%')
            return
        }
        if (sms.trim() == '') {
            app.alert('验证码未填写', 'error', '45%')
            return
        }
        if (name.trim() == '') {
            app.alert('姓名未填写', 'error', '45%')
            return
        }
        if (idno.trim() == '') {
            app.alert('身份证号码未填写', 'error', '45%')
            return
        }
        if (password.trim() == '') {
            app.alert('登录密码未填写', 'error', '45%')
            return
        }
        if (password_confirm.trim() == '') {
            app.alert('再次确认密码未填写', 'error', '45%')
            return
        }
        this.setState({
            loading:true
        })
        let { data, flag, msg } = await app.post(api.ApplyUserRegister, { mobile, sms, name, idno, password, password_confirm })
        if (flag == 1) {
            app.alert(msg, 'success', '45%');
            this.setState({
                applicationFlag: false,
            }, () => {
                this.setState({
                    application_mobile: '',
                    application_sms: '',
                    application_name: '',
                    application_idno: '',
                    application_password: '',
                    application_confirm_password: ''
                })
            })
        } else {
            app.alert(msg, 'error', '45%')
        }
        this.setState({loading:false})

    }


    /*
    *  忘记密码获取手机验证码
    *
    */
    get_forget_Sms = async () => {
        let { forgetMessage_mobile: mobile } = this.state
        if (mobile.trim() == '') {
            app.alert('手机号码未填写', 'error', '45%');
            return
        } else {
            let { flag, msg } = await app.post(api.ApplyUserSendSMS, { mobile })
            if (flag == 1) { app.alert(msg, 'success', '45%'); return }
            app.alert(msg, 'error', '45%')
        }
    }
    /* 
    *   忘记密码
    *
     */
    forgetMessage = async () => {
        let { forgetMessage_mobile: mobile, forgetMessage_sms: sms, forgetMessage_password: password, forgetMessage_confirm_password: password_confirm } = this.state
        if (mobile.trim() == '') {
            app.alert('手机号码未填写', 'error', '45%')
            return
        }
        if (sms.trim() == '') {
            app.alert('验证码未填写', 'error', '45%')
            return
        }
        if (password.trim() == '') {
            app.alert('登录密码未填写', 'error', '45%')
            return
        }
        if (password_confirm.trim() == '') {
            app.alert('再次确认密码未填写', 'error', '45%')
            return
        }
        this.setState({
            loading:true
        })
        let { flag, msg } = await app.post(api.ApplyUserForgotPwd, { mobile, sms, password, password_confirm })
        if (flag != 1) {
            app.alert(msg, 'error', '45%')
            return
        }
        app.alert(msg, 'success', '45%')
        this.setState({
            forgetMessageFlag: false,
        }, () => {
            this.setState({
                forgetMessage_mobile: '',
                forgetMessage_sms: '',
                forgetMessage_password: '',
                forgetMessage_confirm_password: ''
            })
        })
        this.setState({loading:false})


    }

    /* 
    *   提交留言按钮
    *
     */
    submitMessage = async () => {

        let { total } = this.state
        if (total > 0) {
            this.setState({ message_tips_modal: true })
        } else {
            this.continue_submitMessage()
        }



    }

    /* 
    *   提交留言
    *
     */
    continue_submitMessage = async () => {
        let { loginInfo, mitMessage_secret: secret, mitMessage_title: title, mitMessage_content: content, fileList, mitMessage_province: province, mitMessage_city: city, mitMessage_region: region, mitMessage_address: address, mitMessage_teamno: teamno, mitMessage_nickname: nickname, mitMessage_email: email, mitMessage_professional: professional, mitMessage_user_info_secret: user_info_secret, } = this.state, url = []

        if (!title) {
            app.alert('标题未填写', 'error', '45%')
            return
        }
        if (!content) {
            app.alert('内容未填写', 'error', '45%')
            return
        }
        if (fileList.length < 1) {
            app.alert('相关文件未上传', 'error', '45%')
            return
        }
        if (!province) {
            app.alert('未选择省份', 'error', '45%')
            return
        }
        if (!city) {
            app.alert('未选择城市', 'error', '45%')
            return
        }
        if (!region) {
            app.alert('未选择市区', 'error', '45%')
            return
        }
        if (!teamno) {
            app.alert('未搜索选择队伍', 'error', '45%')
            return
        }
        if (!address) {
            app.alert('未填写详细地址', 'error', '45%')
            return
        }

        if (!nickname) {
            app.alert('未填写昵称', 'error', '45%')
            return
        }
        if (!email) {
            app.alert('未填写邮箱', 'error', '45%')
            return
        }
        if (!professional) {
            app.alert('未填写职业', 'error', '45%')
            return
        }
        this.setState({
            loading:true
        })
        fileList.forEach(i => {
            if (i.response.flag == 1) {
                url.push(i.response.data.url)
            }
        })

        url = JSON.stringify(url.join(';;;'))
        url = url.substring(1, url.length - 1);
        // console.log((JSON.stringify(url.join(';;;'))).substring(1,url.length-1))




        let { data, msg, flag } = await app.post(api.InspectionSubmitMessage, { uid: loginInfo.uid, utoken: loginInfo.utoken, secret, title, content, url, province, city, region, address, teamno, nickname, email, professional, user_info_secret })

        if (flag == 1) {
            if (this.state.message_tips_modal) this.setState({ message_tips_modal: false })
            // provinceList: data,
            // cicyList:[],
            // cicyProperList:[]
            this.setState({ mitMessage_secret: 1, mitMessage_title: '', mitMessage_content: '', fileList: [], mitMessage_province: '', mitMessage_city: '', mitMessage_region: '', mitMessage_address: '', mitMessage_teamno: '', mitMessage_nickname: '', mitMessage_email: '', mitMessage_professional: '', mitMessage_user_info_secret: 1, cicyList: [], cicyProperList: [] }, () => app.alert(msg, 'success', '45%'), () => this.dataSource())
        } else {
            app.alert(msg, 'error', '45%')
        }
        this.setState({loading:false})

    }

    /* 
    *   获取我的留言列表
    *
     */
    set_check_my_leavingMessage = async () => {
        this.setState({
            loading:true
        })
        this.setState({ check_my_leavingMessage: true }, () => {
            this.dataSource()
        })
        this.setState({loading:false})
    }

    /* 
    *   撤回留言
    *
     */
    withdraw = async (info) => {
        this.setState({
            loading:true
        })
        let { loginInfo } = this.state

        let { data, flag, msg } = await app.post(api.InspectionMyMessageRevocation, { uid: loginInfo.uid, utoken: loginInfo.utoken, id: info.id })
        if (flag == 1) {
            this.set_check_my_leavingMessage()

            app.alert(msg, 'success', '45%')

        } else {
            app.alert(msg, 'error', '45%')
        }
        this.setState({loading:false})

    }

    /**
     * 数据加载
     * @returns {Promise<void>}
     */
    dataSource = async (page = 1) => {
        await this.setState({ page })
        let { loginInfo } = this.state
        let { flag, data, msg, total } = await app.post(api.InspectionMyMessageList, { uid: loginInfo.uid, utoken: loginInfo.utoken, page })
        if (flag == 1) {

            if (page === this.state.page) {
                await this.setState({
                    my_leavingMessage: data,
                    total: parseInt(total || 0),
                })
            }
        } else {
            // app.alert(msg, "error")
            app.alert(msg, 'error', '45%');

        }

    }
    /**
    *  查看我的留言详情
    * @returns 
    */
    Details = async (info) => {
        this.setState({
            loading:true
        })
        let { loginInfo } = this.state
        let { data, flag, msg } = await app.post(api.InspectionMyMessageDetails, { uid: loginInfo.uid, utoken: loginInfo.utoken, id: info.id })
        if (flag == 1) {
            this.setState({
                message_detail_info: data
            }, () => {
                this.setState({
                    message_detail: true
                })
            })
        } else {
            app.alert(msg, 'error', '45%')
        }
        this.setState({loading:false})

    }


    render() {


        const menu = (
            <Menu>
                <Menu.Item>
                    <div rel="noopener noreferrer" onClick={this.logout}>
                        退出登录
                </div>
                </Menu.Item>

            </Menu>
        );

        const columns = [

            {
                title: '标题',
                width: '20%',
                dataIndex: 'title',
                // key: '1',
            },
            {
                title: '问题归属地',
                width: '20%',
                dataIndex: 'area',
                // key: '2',
            },
            {
                title: '提交时间',
                dataIndex: 'create_time',
                // key: '3',
                width: '20%',

            },
            {
                title: '当前进度',
                // dataIndex: 'audit_title',
                // key: '6',
                width: '20%',
                render: (record) => <div>

                    <p>{record.status_name}</p>
                    <p hidden={!record.status == 1}>{record.status == 1 ? (record.one_audit == 1 ? '通过' : '不通过') : ''}</p>
                    <p hidden={!record.status == 2}>{record.status == 2 ? (record.two_audit == 1 ? '通过' : '不通过') : ''}</p>

                    <p hidden={!(record.one_audit == 2 || record.two_audit == 2)}>
                        <Popover content={record.detail} >
                            <span style={{ color: '#1890ff' }}>查看原因</span>
                        </Popover>
                    </p>
                </div>

            },
            {
                title: '操作',
                key: 'operation',
                width: '20%',
                height: 200,
                render: (record) => <div>
                    <div >
                        <Button style={{ backgroundColor: '#1890FF', color: '#fff', width: 80, height: 30 }} onClick={() => this.Details(record)}>详情</Button>
                    </div>
                    <div style={{ marginTop: 7 }} hidden={record.is_revocation == 1}>
                        <Popconfirm placement="bottom"
                            title="确认撤回吗？"
                            cancelText="取消"
                            okText="确定"
                            onConfirm={() => this.withdraw(record)}
                        >
                            <Button style={{ backgroundColor: '#1890FF', color: '#fff', width: 80, height: 30, }} >撤回</Button>
                        </Popconfirm>

                    </div>
                    <div style={{ marginTop: 7 }} hidden={record.is_revocation == 0}>
                        <Button style={{ color: '#1890FF', width: 80, height: 30 }} >已撤回</Button>
                    </div>




                </div>,
            },
        ];


        let { loading,indexInfo, loginInfo, provinceList, cicyList, cicyProperList, teamList, previewVisible, previewImage, fileList, previewTitle, loginFlag, loginVisible, login_title, applicationFlag, application, forgetMessageFlag, forgetMessage, account, password, application_mobile, application_sms, application_name, application_idno, application_password, application_confirm_password, forgetMessage_mobile, forgetMessage_sms, forgetMessage_password, forgetMessage_confirm_password, mitMessage_secret, mitMessage_user_info_secret,
            check_my_leavingMessage, my_leavingMessage, total, page, message_detail, message_detail_info, message_detail_imgFlag, message_detail_img, message_tips_modal } = this.state
        const uploadButton = (
            <div>
                {/* <PlusOutlined /> */}
                <div style={{ marginTop: 8 }} >上传图片</div>
            </div>
        );
        // nodes = [];
        return (
            <Spin spinning={loading}>

                <div className="inspec">

                    <div className="topNav">
                        <div className="topNav_rightView">

                            <Link to="/" className="topNav_login_option " style={{ width: '10%' }}>
                                返回存心系统
                            </Link>
                            <div className="topNav_login">
                                {
                                    loginInfo.length < 1 ?
                                        (<div className="topNav_login_option" onClick={this.ifLogin}>
                                            登录
                                        </div>)
                                        : (<Dropdown overlay={menu} >
                                            <div className="ant-dropdown-link topNav_login_option">
                                                {loginInfo.login_name}
                                            </div>
                                        </Dropdown>)
                                }

                            </div>
                        </div>
                    </div>

                    <div className="blue-bg">
                        <div className="banner">
                        </div>

                        <div className="container navbar">
                            <div className="nav zhuanti-nav">
                                <a href="http://localhost:3000/Inspection#brief" onClick={() => this.setState({ check_my_leavingMessage: false })}><img src="../assets/head_default_img.png" alt="" /> 公告</a>
                                {/* <a href="https://tousu.www.gov.cn/dc/zhuanti.htm" target="_blank"><img src="./国务院“互联网+督查”平台_中国政府网_files/20200528zt.jpg" alt="" /> 专题征集</a> */}
                                {/* <a href="https://tousu.www.gov.cn/dc/index.htm#expose"><img src="./国务院“互联网+督查”平台_中国政府网_files/h133.png" alt="" /> 曝光台</a> */}
                                <a href="http://localhost:3000/Inspection#dchs" className="bgt" onClick={() => this.setState({ check_my_leavingMessage: false })}><img src="./国务院“互联网+督查”平台_中国政府网_files/h133.png" alt="" /> 督查回声</a>
                                <a href="http://localhost:3000/Inspection#message" onClick={() => this.setState({ check_my_leavingMessage: false })}><img src="./国务院“互联网+督查”平台_中国政府网_files/h134.png" alt="" /> 我要留言</a>
                                <a onClick={this.set_check_my_leavingMessage} hidden={!loginFlag}><img src="./国务院“互联网+督查”平台_中国政府网_files/h135.png" alt="" /> 我的留言</a>
                            </div>
                        </div>

                        <div className="container" hidden={check_my_leavingMessage}>

                            {/* <!-- 简介 --> */}
                            <a name="brief"></a>
                            <div className="brief radius">
                                <p className="gonggao">公&nbsp;&nbsp;告</p>
                                <p>
                                    {indexInfo.length != 0 ? indexInfo.bulletin : '暂无公告'}
                                </p>
                                {/* <p>　　我们将对收到的问题线索和意见建议进行汇总整理，督促有关地方、部门处理。对企业和群众反映强烈、带有普遍性的重要问题线索，将由国务院办公厅督查室直接派员进行督查。经查证属实、较为典型的问题，将予以公开曝光、严肃处理。
                            </p> */}
                                <p className="inscription">
                                    {/* 国务院办公厅&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br />2019年4月22日&nbsp;&nbsp;&nbsp;&nbsp; */}
                                </p>
                                <div className="decorate-top"><img src="https://tousu.www.gov.cn/dc/images/h102.png" className="img-responsive" alt="" /></div>
                                <div className="decorate-bottom"><img src="https://tousu.www.gov.cn/dc/images/h103.png" className="img-responsive" alt="" /></div>
                            </div>
                        </div>

                        {/* 我的留言 */}
                        <div className="container my_leavingMessage" hidden={!check_my_leavingMessage}>
                            <Table columns={columns} dataSource={my_leavingMessage} scroll={{ y: 1000 }}
                                rowKey={record => record.id}
                                pagination={false}
                                footer={() => {
                                    return (
                                        <Row hidden={my_leavingMessage.length === 0}>
                                            <Col span={12} style={{ textAlign: 'left' }}>
                                                <div>进度流程：{'提交审核->信息初审->督察组处理->公示（同意公开留言内容）'}</div>
                                            </Col>
                                            <Col span={24} style={{ textAlign: 'right' }}>
                                                <Pagination total={total} size="small" pageSize={20} current={page}
                                                    showTotal={(total) => `总数量：${total}`}
                                                    onChange={this.dataSource} />
                                            </Col>
                                        </Row>
                                    )
                                }} />
                        </div>
                    </div>

                    <div className="cyan-bg expose supervisionEcho" hidden={check_my_leavingMessage}>
                        <a name="dchs"></a>

                        <h1 className="line-bg">督查回声</h1>
                        <div className="container">
                            {/* <iframe src="./国务院“互联网+督查”平台_中国政府网_files/duchahuisheng_iframe.html" id="iframeSupervisionEcho" name="iframeSupervisionEcho" width="100%" scrolling="no" marginheight="0" frameborder="0" style="height: 1360px;"></iframe> */}


                            <div className="content" id="content2">
                                <ul className="duchaHeader">
                                    <li>
                                        <h3>
                                            <a>{indexInfo.length != 0 ? indexInfo.inspector_summary.title : ''}</a>
                                        </h3>
                                        <p>
                                            {indexInfo.length != 0 ? indexInfo.inspector_summary.content : ''}
                                        </p>
                                        {/* <p>
                                        为更好回应企业和群众关切，主动接受社会监督，国务院办公厅督查室从即日起开辟“督查回声”专栏，不定期发布国务院办公厅督查室直接派员核查或各地区各部门反馈的有关问题线索办理结果。欢迎广大企业和群众继续通过国务院“互联网+督查”平台反映问题，提出建议。
                                    </p> */}

                                    </li>

                                </ul>
                                <div className="duchaContent">

                                    {
                                        indexInfo.length != 0 ? (
                                            indexInfo.inspector_echo.length != 0 ? indexInfo.inspector_echo.map((i, v) => {
                                                return (
                                                    <div className="duchaContentItem" key={i.id}>
                                                        <h4 className="lymemo pcSubTitle"><a href="/hudong/ducha/2021-04/23/content_5601649.htm" target="_blank">{i.simple_reply}
                                                        </a></h4>

                                                        {/* <h4 className="mobileGaojianTitle">
                                        <a href="/hudong/ducha/2021-04/23/content_5601649.htm" target="_blank">襄阳市群众反映残疾人证换领来回跑花费高 襄阳市政府积极优化残疾人办证服务全额承担残疾人评定有关费用</a>
                                    </h4> */}
                                                        <h5>{i.reaction}</h5>
                                                        <p className="lymemo">&nbsp;{i.title}</p>
                                                        <div className="bldwhcqk">
                                                            {i.respond_to}
                                                            {/* <span>国办督查室收到杨先生留言后,经初步核实,及时转湖北省政府核查办理。</span>湖北省政府接到国办督查室转送的问题线索后，立即组织核查办理。经核查，群众反映情况属实。反映人家属在原残疾人证有效期满后，到襄阳市樊城区行政服务中心残联办事服务窗口申请换领新残疾人证。在办理过程中，窗口工作人员发现当事人办证医学鉴定档案缺失，按照规定须重新进行听力医学鉴定，以确定其残疾类别和级别，方可换领新证。 */}
                                                            {/* <a href="/hudong/ducha/2021-04/23/content_5601649.htm" className="lookQuanwen" target="_blank">查看全文&gt;&gt;</a> */}
                                                        </div>
                                                        <span className="dcfgrq">{i.reply_time}</span>
                                                    </div>
                                                )
                                            }) : ''
                                        ) : '暂无数据'
                                    }




                                </div>
                                <div className="lookMore" id="lookMore" style={{ display: 'block' }}><Link to="/Inspection/supervisorEchoList">查看更多</Link></div>


                            </div>



                        </div>
                    </div>

                    <div className="sand-bg pt40" id="md" style={{ background: '#ebf0f8' }} onClick={this.ifLogin} hidden={check_my_leavingMessage}>
                        <a name="message"></a>

                        <h1 className="line-bg" style={{ paddingTop: 30 }}>我要留言</h1>
                        <div className="container form-box dn show">
                            <div className="top_title">
                                <div className="title">
                                    <h2>留言内容</h2>
                                    <div className="title_check">
                                        <Checkbox onChange={this.check} checked={mitMessage_secret == "2" ? true : false} name="mitMessage_secret"></Checkbox>
                                        <span className="span1">同意公开留言内容</span>
                                        <span className="span2">《留言须知》</span>
                                    </div>

                                </div>
                                <div className="titleInput">
                                    <Input placeholder="必填" style={{ height: 43 }} prefix={'标题：'} onChange={this._changeValue} name="mitMessage_title" value={this.state.mitMessage_title} />
                                    <TextArea placeholder="正文：请尽量提供所反应问题或事项涉及的时间、地点、单位、政策依据等要素。如有证据资料，可在留言中注明。" maxLength={100} style={{ marginTop: 40, height: 291 }} onChange={this._changeValue} name="mitMessage_content" value={this.state.mitMessage_content}></TextArea>
                                </div>

                                <div >
                                    <div style={{ paddingTop: 30, paddingBottom: 10 }}>相关文件</div>
                                    {/* 图片上传 */}
                                    <Upload
                                        accept='image/jpeg, image/jpg, image/png'
                                        action={config.serverUrl + "/Inspection/imageUpload"}
                                        name="image"
                                        listType="picture-card"
                                        fileList={fileList}
                                        onPreview={this.handlePreview}
                                        onChange={this.handleChange}
                                        beforeUpload={beforeUpload}
                                        disabled={!loginFlag}
                                    >
                                        {fileList.length >= 5 ? null : uploadButton}
                                    </Upload>
                                    {/* 上传图片预览弹窗 */}
                                    <Modal
                                        visible={previewVisible}
                                        title={previewTitle}
                                        footer={null}
                                        onCancel={this.handleCancel}
                                    >
                                        <img alt="example" style={{ width: '100%' }} src={previewImage} />
                                    </Modal>

                                </div>
                            </div>


                            <div className="problemAttribution">
                                <div className="title">
                                    <h2>问题归属</h2>


                                </div>



                                <Select defaultValue="选择省份" style={{ width: 150 }} disabled={!loginFlag} onChange={this.getCity}>
                                    {
                                        provinceList.length > 0 ? provinceList.map(i => {
                                            return <Option key={i.region_id} value={i.region_id}>{i.region_name}</Option>
                                        }) : ''
                                    }

                                </Select>


                                <Select defaultValue="选择城市" style={{ width: 150 }} disabled={!loginFlag} onChange={this.get_cicyProperList}>
                                    {
                                        cicyList.length > 0 ? cicyList.map(i => {
                                            return <Option key={i.region_id} value={i.region_id}>{i.region_name}</Option>
                                        }) : ''
                                    }

                                </Select>


                                <Select defaultValue="选择市区" style={{ width: 150 }} disabled={!loginFlag} onChange={this.getCity}>
                                    {
                                        cicyProperList.length > 0 ? cicyProperList.map(i => {
                                            return <Option key={i.region_id} value={i.region_id}>{i.region_name}</Option>
                                        }) : ''
                                    }

                                </Select>






                                <AutoComplete
                                    style={{ height: 50, width: 200, marginLeft: 50 }}
                                    dataSource={teamList}
                                    filterOption={(inputValue, option) =>
                                        option.props.children.includes(inputValue)
                                    }
                                    onChange={this.onChangeTeamName}
                                    placeholder="搜索队伍"
                                    value={this.state.searchTeamnoValue}

                                />
                                <Button style={{ backgroundColor: '#1890FF', color: '#fff' }} onClick={this.getTeamMember}>搜索</Button>
                                {/* || this.props.apply == 1 */}

                                <div className="problemAttribution_input">
                                    <Input placeholder="" style={{ height: 43, width: '100%' }} prefix={'详细地址：'} onChange={this._changeValue} name="mitMessage_address" value={this.state.mitMessage_address} />
                                </div>





                            </div>


                            <div className="personInfo">
                                <div className="title">
                                    <h2>个人信息</h2>
                                    <div className="title_check">
                                        <Checkbox onChange={this.check} checked={mitMessage_user_info_secret == "2" ? true : false} name="mitMessage_user_info_secret"></Checkbox>
                                        <span className="span1">保密个人信息</span>
                                        <span className="span2">（注：如选择保密，可能会影响你反应问题的解决效果。）</span>
                                    </div>

                                </div>
                                <div className="personInfo_inputList">
                                    <div>
                                        <Input placeholder="必填" style={{ height: 43, width: '100%' }} prefix={'姓名：'} value={loginInfo.length != 0 ? loginInfo.name : ''} disabled={loginInfo.length != 0 ? true : false} />
                                    </div>
                                    <div style={{ paddingLeft: '5%' }}>
                                        <Input placeholder="必填" style={{ height: 43, width: '100%' }} prefix={'昵称：'} onChange={this._changeValue} name="mitMessage_nickname" value={this.state.mitMessage_nickname} />
                                    </div>
                                    <div>
                                        <Input placeholder="必填" style={{ height: 43, width: '100%' }} prefix={'电话：'} value={loginInfo.length != 0 ? loginInfo.mobile : ''} disabled={loginInfo.length != 0 ? true : false} />
                                    </div>
                                    <div style={{ paddingLeft: '5%' }}>
                                        <Input placeholder="" style={{ height: 43, width: '100%' }} prefix={'邮箱：'} onChange={this._changeValue} name="mitMessage_email" value={this.state.mitMessage_email} />
                                    </div>
                                    <div className="idno">
                                        <Input placeholder="必填" style={{ height: 43, width: '100%' }} prefix={'公民身份号码：'} value={loginInfo.length != 0 ? loginInfo.idno : ''} disabled={loginInfo.length != 0 ? true : false} />
                                    </div>
                                    <div style={{ paddingLeft: '5%' }}>
                                        <Input placeholder="" style={{ height: 43, width: '100%' }} prefix={'职业：'} onChange={this._changeValue} name="mitMessage_professional" value={this.state.mitMessage_professional} />
                                    </div>
                                    {/* <div style={{ display: 'flex' }}>
                                    <div style={{ width: 50, paddingTop: 12 }}>验证码</div>
                                    <Input placeholder="必填" style={{ height: 43, width: '100%' }} />
                                </div> */}


                                </div>

                                <div className="personInfo_button_view">
                                    <Button className="personInfo_button" onClick={this.submitMessage}>提交留言</Button>

                                </div>


                                <div className="personInfo_button_view_bottom">
                                    <Button className="personInfo_button" onClick={() => this.setState({ mitMessage_secret: 1, mitMessage_title: '', mitMessage_content: '', mitMessage_url: [], mitMessage_province: '', mitMessage_city: '', mitMessage_region: '', mitMessage_address: '', mitMessage_teamno: '', mitMessage_nickname: '', mitMessage_email: '', mitMessage_professional: '', mitMessage_user_info_secret: 1, })}>重置信息</Button>
                                </div>

                            </div>



                            <div className="point-out radius bg-opcity" style={{ margin: 70 }}>
                                <p>　　如你想反映贪污腐败问题、涉法涉诉问题、违法犯罪问题以及其他不在本平台征集范围内的问题，请依法依规向纪检监察机关、司法机关、公安机关、信访部门以及政府相关职能部门反映。</p>
                                <div className="link text-center">
                                    <a href="http://www.12388.gov.cn/" target="_blank">中央纪委国家监委举报网站</a> | <a href="http://ssxf.court.gov.cn/" target="_blank">最高人民法院网上申诉信访平台</a> | <a href="https://jubao.12309.gov.cn/" target="_blank">最高人民检察院举报中心</a> | <a href="http://www.mps.gov.cn/n2254536/n4904356/index.html" target="_blank">公安部投诉举报网站</a> | <a href="http://wsxf.gjxfj.gov.cn/zfp/webroot/index.html" target="_blank">国家信访局网上信访大厅</a>
                                </div>
                            </div>
                        </div>

                    </div>


                    {/* 登录弹窗 */}
                    <Modal
                        visible={loginVisible}
                        // title={previewTitle}
                        footer={null}
                        onCancel={this.handleCancelLogin}
                        width={700}
                    >
                        <Spin spinning={loading}>
                        <div>
                            <div className="login_topNav">
                                {/* <div className="active">系统身份登录</div>
                            <div>游客登录</div> */}
                                {
                                    (forgetMessageFlag ? forgetMessage : (applicationFlag ? application : login_title))
                                        .map((i, v) => <div key={i.id} className={i.active ? 'active' : ''} onClick={() => this.setTopNav(v)}>{i.title}</div>)
                                }
                            </div>

                            <div className="login_show">
                                <div hidden={applicationFlag || forgetMessageFlag}>
                                    <div className="login_showItem" hidden={!login_title[0].active}>
                                        <Input size="large" placeholder="请输入系统注册手机号码" prefix={<Icon type="mobile" />} className="showItem_input" value={account} onChange={this._changeValue} name="account" />
                                        <Input.Password autocomplete="off" size="large" placeholder="请输入系统登录密码" prefix={<Icon type="unlock" />} className="showItem_input" value={password} onChange={this._changeValue} name="password" />
                                        <div className="showItem_forgetMessage" onClick={() => this.setState({ forgetMessageFlag: true })}>忘记密码？</div>
                                        <div className="showItem_buttom_view"><Button type="primary" size="small" className="showItem_buttom" onClick={() => this.login(1)}>登录</Button></div>
                                    </div>
                                    <div className="login_showItem" hidden={!login_title[1].active}>
                                        <Input size="large" placeholder="请输入系统注册手机号码" prefix={<Icon type="mobile" />} className="showItem_input" value={account} onChange={this._changeValue} name="account" />
                                        <Input.Password autocomplete="off" size="large" placeholder="请输入系统登录密码" prefix={<Icon type="unlock" />} className="showItem_input" value={password} onChange={this._changeValue} name="password" />
                                        <div className="showItem_forgetMessage" onClick={() => this.setState({ forgetMessageFlag: true })}>忘记密码？</div>
                                        <div className="showItem_buttom_view"><Button type="primary" size="small" className="showItem_buttom" onClick={() => this.login(2)}>登录</Button></div>
                                        <div className="showItem_buttom_view"><Button type="" size="small" className="showItem_buttom" onClick={() => this.setState({ applicationFlag: true })}>立即注册</Button></div>
                                    </div>
                                </div>


                                <div className="login_application" hidden={!applicationFlag}>
                                    <div>
                                        <label htmlFor=""><span>*</span>手机号码</label>
                                        <Input size="large" placeholder="请输入手机号码" className="application_input" onChange={this._changeValue} value={application_mobile} name="application_mobile" />
                                    </div>
                                    <div>
                                        <label htmlFor=""><span>*</span>短信验证码</label>
                                        <Search
                                            placeholder="请输入短信验证码"
                                            allowClear
                                            enterButton="获取短信验证码"
                                            size="large"
                                            onSearch={this.getSms}
                                            className="application_input" onChange={this._changeValue} value={application_sms} name="application_sms"
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor=""><span>*</span>姓名</label>
                                        <Input size="large" placeholder="请输入姓名" className="application_input" onChange={this._changeValue} value={application_name} name="application_name" />
                                    </div>

                                    <div>
                                        <label htmlFor=""><span>*</span>身份证号码</label>
                                        <Input size="large" placeholder="请输入身份证号码" className="application_input" onChange={this._changeValue} value={application_idno} name="application_idno" />
                                    </div>

                                    <div>
                                        <label htmlFor=""><span>*</span>登录密码</label>
                                        <Input.Password size="large" placeholder="请输入登录密码" className="application_input" onChange={this._changeValue} value={application_password} name="application_password" />
                                    </div>

                                    <div>
                                        <label htmlFor=""><span>*</span>确认密码</label>
                                        <Input.Password size="large" placeholder="请再次输入登录密码" className="application_input" onChange={this._changeValue} value={application_confirm_password} name="application_confirm_password" />
                                    </div>

                                    <div className="showItem_buttom_view application_buttom_view"><Button type="primary" size="small" className="application_buttom" onClick={this.application}>立即注册</Button></div>

                                    <div className="showItem_buttom_view application_buttom_view"><Button type="" size="small" className="application_buttom" onClick={() => this.setState({ applicationFlag: false, application_mobile: '', application_sms: '', application_name: '', application_idno: '', application_password: '', application_confirm_password: '' })}>返回</Button></div>
                                </div>

                                <div className="login_application login_forgetMessager" hidden={!forgetMessageFlag}>
                                    <div>
                                        <label htmlFor=""><span>*</span>手机号码</label>
                                        <Input size="large" placeholder="请输入手机号码" className="application_input" onChange={this._changeValue} value={forgetMessage_mobile} name="forgetMessage_mobile" />
                                    </div>
                                    <div>
                                        <label htmlFor=""><span>*</span>短信验证码</label>
                                        <Search
                                            placeholder="请输入短信验证码"
                                            allowClear
                                            enterButton="获取短信验证码"
                                            size="large"
                                            onSearch={this.get_forget_Sms}
                                            className="application_input"
                                            onChange={this._changeValue} value={forgetMessage_sms} name="forgetMessage_sms"
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor=""><span>*</span>登录密码</label>
                                        <Input.Password size="large" placeholder="请输入登录密码" className="application_input" onChange={this._changeValue} value={forgetMessage_password} name="forgetMessage_password" />
                                    </div>

                                    <div>
                                        <label htmlFor=""><span>*</span>确认密码</label>
                                        <Input.Password size="large" placeholder="请再次输入登录密码" className="application_input" onChange={this._changeValue} value={forgetMessage_confirm_password} name="forgetMessage_confirm_password" />
                                    </div>

                                    <div className="showItem_buttom_view application_buttom_view"><Button type="primary" size="small" className="application_buttom" onClick={this.forgetMessage}>提交</Button></div>

                                    <div className="showItem_buttom_view application_buttom_view"><Button type="" size="small" className="application_buttom" onClick={() => this.setState({ forgetMessageFlag: false, forgetMessage_mobile: '', forgetMessage_sms: '', forgetMessage_password: '', forgetMessage_confirm_password: '' })}>返回</Button></div>
                                </div>
                            </div>
                        </div>
                        </Spin>
                    </Modal>
                    {/* 我的留言详情 */}
                    <Modal
                        visible={message_detail}
                        // title={previewTitle}
                        footer={null}
                        onCancel={() => this.setState({ message_detail: false })}
                        width={1300}
                    >
                        <div style={{ paddingLeft: 350, fontSize: 22 }}>
                            <div style={{ display: 'flex', marginTop: 20 }}>
                                <div style={{ width: 170 }}>公开留言内容：</div>
                                <div style={{ width: 730 }}>{(message_detail_info.secret == 1 ? '同意' : '不同意')}</div>
                            </div>

                            <div style={{ display: 'flex', marginTop: 20 }}>
                                <div style={{ width: 170 }}>标题：</div>
                                <div style={{ width: 730 }}>{message_detail_info.title}</div>
                            </div>
                            <div style={{ display: 'flex', marginTop: 20 }}>
                                <div style={{ width: 170 }}>内容：</div>
                                <div style={{ width: 730 }}>{message_detail_info.content}</div>
                            </div>
                            <div style={{ display: 'flex', marginTop: 20 }}>
                                <div style={{ width: 170 }}>相关文件：</div>
                                <div style={{ width: 730 }}>
                                    {
                                        (message_detail_info.url != undefined && message_detail_info.url.length > 0 ? (message_detail_info.url).map(i => {
                                            return <img src={config.imgUrl + i} key={i} style={{ cursor: 'pointer' }} alt="" onClick={() => this.setState({ message_detail_imgFlag: true, message_detail_img: i })} />
                                        }) : '暂无相关文件')
                                    }
                                </div>
                            </div>
                            <div style={{ display: 'flex', marginTop: 20 }}>
                                <div style={{ width: 170 }}>问题归属：</div>
                                <div style={{ width: 730 }}>{message_detail_info.province + message_detail_info.city + message_detail_info.region}</div>
                            </div>
                            <div style={{ display: 'flex', marginTop: 20 }}>
                                <div style={{ width: 170 }}>详细地址：</div>
                                <div style={{ width: 730 }}>{message_detail_info.address}</div>
                            </div>
                            <div style={{ display: 'flex', marginTop: 20 }}>
                                <div style={{ width: 170 }}>问题归属队伍：</div>
                                <div style={{ width: 730 }}>{message_detail_info.teamname}</div>
                            </div>
                            <div style={{ display: 'flex', marginTop: 20 }}>
                                <div style={{ width: 170 }}>提交时间：</div>
                                <div style={{ width: 730 }}>{message_detail_info.create_time}</div>
                            </div>
                            <div style={{ display: 'flex', marginTop: 20 }}>
                                <div style={{ width: 170 }}>个人信息：</div>
                                <div style={{ width: 730 }}>{(message_detail_info.user_info_secret == 1 ? '保密' : '不保密')}</div>
                            </div>
                            <div style={{ display: 'flex', marginTop: 20 }}>
                                <div style={{ width: 170 }}>当前进度：</div>
                                <div style={{ width: 730 }}>
                                    {/* {message_detail_info.length > 0 ? message_detail_info.status_name : ''} */}
                                    {

                                        message_detail_info.status == 0 ? '提交审核' :
                                            (message_detail_info.status == 10 ? '公示' :
                                                (message_detail_info.status == 1 ? '信息初审' + '(' + (message_detail_info.one_audit == 1 ? '通过' : '不通过') + ')' :
                                                    (message_detail_info.status == 2 ? '督察组处理' + '(' + (message_detail_info.two_audit == 1 ? '通过' : '不通过') + ')' : '')))
                                    }
                                </div>
                            </div>

                            <div style={{ display: 'flex', marginTop: 20 }} hidden={!(message_detail_info.one_audit == 2 || message_detail_info.two_audit == 2)}>
                                <div style={{ width: 170 }}>不通过原因：</div>
                                <div style={{ width: 730 }}>{message_detail_info.detail}</div>
                            </div>


                        </div>
                        <p style={{ color: '#fb6920', textAlign: 'center', marginTop: 200 }}>{'进度流程：提交审核->信息初审->督察组处理->公示（同意公开留言内容）'}</p>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 50 }}>
                            <Button style={{ width: 200, color: '#1890FF', marginRight: 30 }} onClick={() => this.setState({ message_detail: false })}>关闭</Button>
                        </div>
                    </Modal>
                    {/* 我的留言详情图片预览 */}
                    <Modal
                        visible={message_detail_imgFlag}
                        footer={null}
                        onCancel={() => this.setState({ message_detail_imgFlag: false })}
                        width={1300}
                    >
                        <img alt="example" style={{ width: '100%', }} src={config.imgUrl+message_detail_img} />
                    </Modal>
                    {/* 留言提示              */}
                    <Modal
                        visible={message_tips_modal}
                        footer={null}
                        onCancel={() => this.setState({ message_tips_modal: false })}
                    >
                        <p>你已有{total}条留言内容，是否继续提交？</p>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 50 }}>
                            <Button style={{ width: 200, color: '#1890FF', marginRight: 30 }} onClick={() => this.setState({ check_my_leavingMessage: true, message_tips_modal: false })}>前往查看</Button>
                            <Button style={{ width: 200, color: '#1890FF', marginRight: 30 }} onClick={this.continue_submitMessage}>继续提交</Button>
                        </div>

                    </Modal>


                </div>
            </Spin>

        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/Inspection.jsx